var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80741 9.36462L13.1866 9.36357C13.3752 9.36328 13.5343 9.29814 13.6639 9.16815C13.7931 9.03847 13.8576 8.87935 13.8574 8.69079C13.8571 8.50223 13.7919 8.34315 13.6619 8.21355C13.5323 8.08427 13.3731 8.01978 13.1846 8.02007L4.80539 8.04469L8.38257 4.45653C8.51593 4.32276 8.58263 4.16552 8.58266 3.98482C8.58207 3.80411 8.51489 3.64708 8.38112 3.51372C8.24735 3.38036 8.09012 3.31366 7.90941 3.31363C7.72871 3.31422 7.57168 3.3814 7.43832 3.51517L2.7315 8.23643C2.59814 8.3702 2.5316 8.52728 2.53187 8.70767C2.53215 8.88869 2.59917 9.04588 2.73294 9.17924L7.45421 13.8861C7.58797 14.0194 7.74521 14.0858 7.92592 14.0852C8.10662 14.0852 8.26365 14.0184 8.39701 13.8846C8.53037 13.7508 8.59676 13.5936 8.59617 13.4129C8.5962 13.2322 8.52934 13.0752 8.39557 12.9418L4.80741 9.36462Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackGray);
export default __webpack_public_path__ + "static/media/arrow-back-gray.6c09abe6f3028af4f5a13d9fdc77cb57.svg";
export { ForwardRef as ReactComponent };